_ = require('underscore');
module.exports = {
    "button-view-template": function(obj) {
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
__p += '\n    <li class="top-align' +
((__t = ( obj.btnWrapperClass ? ' ' + obj.btnWrapperClass : '' )) == null ? '' : __t) +
'">\n        <button class="btn ' +
((__t = ( obj.className ? obj.className : 'btn-default' )) == null ? '' : __t) +
'' +
((__t = ( obj.type ? ' ' + obj.type : '' )) == null ? '' : __t) +
'' +
((__t = ( obj.primary ? ' button-primary' : '' )) == null ? '' : __t) +
'" ' +
((__t = ( obj.dataTn ? 'data-tn="' + obj.dataTn + '"' : '' )) == null ? '' : __t) +
'>' +
((__t = ( obj.text )) == null ? '' : __t) +
'</button>\n        ';
 if (obj.help) { ;
__p += '\n        <div class="help text-muted small-line-height' +
((__t = ( (obj.helpClass) ? ' ' + obj.helpClass : '')) == null ? '' : __t) +
'"><small>' +
((__t = ( obj.help )) == null ? '' : __t) +
'</small></div>\n        ';
 } ;
__p += '\n    </li>\n';
return __p
}
};


//////////////////
// WEBPACK FOOTER
// ./~/dibs-button-view/template.html
// module id = 717
// module chunks = 4 6 7 8 9 13 17